import { useEffect, useState } from "react";
import styled from "styled-components";
import { Rating } from "@mui/material";
import { StarBorderRounded, StarRounded } from "@mui/icons-material";
import BaseModal from "../modal/Base.modal";
import Review from "../../models/Review.model";
import TextAreaView from "../commons/TextArea.view";
import useAppMutation from "../../hooks/useAppMutation";
import { ReviewApi } from "../../api/Review.api";
import { useQueryClient } from "@tanstack/react-query";
import Error from "../../models/Error.model";

type EditReviewModalProps = {
  review: Review | null
  onCancel: () => void
  onSuccess: () => void
}

export default function EditReviewModal(props: EditReviewModalProps) {

  const queryClient = useQueryClient();
  const {mutate: createReview} = useAppMutation({
    mutationFn: ReviewApi.create,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['user']});
      props.onSuccess()
    },
    onError: (error) => {
      if(error instanceof Error) {
        alert(error.message);
      } else {
        alert('리뷰 작성에 실패했습니다.');
      }
    }
  });

  const {mutate: updateReview} = useAppMutation({
    mutationFn: ({id, rating, description}: {id: number, rating: number, description: string}) =>
      ReviewApi.edit(id, {rating, description}),
    onSuccess: () => {
      props.onSuccess()
    },
    onError: (error) => {
      if(error instanceof Error) {
        alert(error.message);
      } else {
        alert('리뷰 수정에 실패했습니다.');
      }
    }
  });



  const [description, setDescription] = useState('')
  const [rating, setRating] = useState(0)

  useEffect(() => {
    if(props.review === null) return

    setDescription(props.review.description)
    setRating(props.review.rating)
  }, [props.review])

  const addReview = () => {
    createReview({rating, description})
  }

  const editReview = (id: number) => {
    updateReview({id, rating, description})
  }

  return (
    <BaseModal
      title={`리뷰 ${props.review === null ? '추가' : '수정'}`}
      onClickLeftButton={props.onCancel}
      rightButtonText={props.review === null ? '추가' : '수정'}
      onClickRightButton={() => props.review === null ? addReview() : editReview(props.review.id)}
    >
      <EditReviewSection className="card_middle">
        <Rating
          precision={0.5}
          value={rating}
          onChange={(event, newValue) => {
            setRating(newValue||0);
          }}
          icon={<StarRounded />}
          emptyIcon={<StarBorderRounded />}
        />
        
        <TextAreaView
          value={description}
          onChange={setDescription}
          placeholder="리뷰 내용"
        />
      </EditReviewSection>
    </BaseModal>
  )
}

const EditReviewSection = styled.section`
  width: 700px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 24px;

  .MuiRating-root{
    display: flex;
    label{
      .MuiRating-icon{
        width: 36px;
        height: 36px;
        .MuiSvgIcon-root{
          width: 100%;
          height: 100%;
        }
      }
    }
  }
`